import { defineComponent as _defineComponent } from 'vue'
import InstrumentDetails from '@/modules/wallet-builder/src/components/Instruments/InstrumentDetails/InstrumentDetails.vue';
import OrderDetails from '../OrderDetails/OrderDetails.vue';
import { OrderModalStep } from './types';
import { computed, onMounted, ref, watch } from 'vue';
import {
  trackDownloadButton,
  trackLoadInstrumentDetails
} from '@/modules/wallet-builder/src/components/Instruments/track-events';
import { IInstrumentDetails } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import {
  getOrderReceiptDetails,
  IOrderReceipt
} from '@/modules/wealth/services/wealth-orders';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderModal',
  props: {
  isOpen: { type: Boolean, default: false },
  orderId: { type: String, default: '' }
},
  emits: ['close', 'reload'],
  setup(__props, { emit }) {

const props = __props

const step = ref<OrderModalStep>(OrderModalStep.OrderDetails);
const instrumentDetailApiId = ref<string>(
  '1996e327-05d8-11ec-a044-0aae9b4e6433'
);
const orderDetails = ref<IOrderReceipt | null>(null);
const isLoadingOrderDetails = ref(false);
const isErrorOrderDetails = ref(false);

function handleInstrumentDetailsClick() {
  step.value = OrderModalStep.InstrumentDetails;
  instrumentDetailApiId.value = orderDetails.value?.productApiId ?? '';
}

function trackLoadInstrument(instrument: IInstrumentDetails) {
  trackLoadInstrumentDetails(false, instrument);
}

function trackDownload(title: string) {
  trackDownloadButton(false, title);
}



watch(
  () => props.isOpen,
  (newVal: boolean) => {
    if (newVal && step.value === OrderModalStep.OrderDetails) {
      requestOrderReceipt();
    } else if (!newVal) {
      isLoadingOrderDetails.value = true;
      orderDetails.value = null;
    }
  }
);

onMounted(() => {
  if (props.isOpen && step.value === OrderModalStep.OrderDetails) {
    requestOrderReceipt();
  }
});

async function requestOrderReceipt() {
  isErrorOrderDetails.value = false;
  try {
    isLoadingOrderDetails.value = true;
    orderDetails.value = await getOrderReceiptDetails(props.orderId ?? '');
  } catch (error) {
    isErrorOrderDetails.value = true;
  } finally {
    isLoadingOrderDetails.value = false;
  }
}

const isOrderDetailsOpen = computed(
  () => step.value === OrderModalStep.OrderDetails && props.isOpen
);

const isInstrumentDetailsOpen = computed(
  () => step.value === OrderModalStep.InstrumentDetails
);



return { __sfc: true,step, instrumentDetailApiId, orderDetails, isLoadingOrderDetails, isErrorOrderDetails, handleInstrumentDetailsClick, trackLoadInstrument, trackDownload, props, requestOrderReceipt, isOrderDetailsOpen, isInstrumentDetailsOpen, emit, InstrumentDetails, OrderDetails, OrderModalStep }
}

})